module.exports = __webpack_public_path__ + "static/img/特色创新1.5e5871cb.png";